// src/redux/reducers/eventReducers.js

const initialState = {
    events: [],
    filteredEvents: [],
    eventType: '',
    noEventsMessage: ''
  };
  
  // Example of event reducer logic
  const eventReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_EVENTS':
        return {
          ...state,
          events: action.payload
        };
      case 'SET_FILTERED_EVENTS':
        return {
          ...state,
          filteredEvents: action.payload
        };
      case 'SET_EVENT_TYPE':
        return {
          ...state,
          eventType: action.payload
        };
      case 'SET_NO_EVENTS_MESSAGE':
        return {
          ...state,
          noEventsMessage: action.payload
        };
      default:
        return state;
    }
  };
  
  export default eventReducer;  // Default export
  